module.exports = __webpack_public_path__ + "images/emoji/alien.0ec0088f4c9ea7ac4e91.png";